import React, { useState } from "react";
import classes from "./TagInput.module.scss";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getKeyGen } from "../../../../helpers";
import { useTranslation } from "react-i18next";

const TagInput = ({
  autoComplete = "off",
  centerText = false,
  className = "",
  errors = null,
  forward_ref = null,
  label = null,
  maxLength = "",
  required = true,
  msgInfo = false,
  name = "",
  onChange = "",
  parentClass = null,
  placeholder = "",
  type = "text",
  value = "",
  mask = "",
  inputmode = "",

}) => {
  const { t } = useTranslation();
  const [isPasswodShow, setIsPasswodShow] = useState(false);
  let errorClass = classes.Error;
  const inputeCenterClass = centerText ? " " + classes.CenterText : "";
  const isPasswod = type === "password";
  let tempType = type;

  const keyPresed = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setIsPasswodShow(!isPasswodShow);
    }
  };

  if (isPasswodShow) tempType = "text";
  if (msgInfo) errorClass = classes.Error + " " + classes.MsgInfo;
  if (className) className = " " + className;
  let finalInput = (
    <div className={className}>
      {label && (
        <label className={classes.Label} htmlFor={"id_" + [name]}>
          {label}
        </label>
      )}
      <div className={classes.InputEyeArea}>
        <input
          className={classes.TagInput + inputeCenterClass}
          value={value}
          mask={mask}
          inputMode={inputmode}
          id={getKeyGen("id_" + name)}
          maxLength={(maxLength) ? parseInt(maxLength):""}
          name={name}
          type={tempType}
          required={required}
          autoComplete={autoComplete}
          onChange={onChange}
          placeholder={placeholder}
          ref={forward_ref}
        />
        {isPasswod && (
          <FontAwesomeIcon
            onKeyDown={(e) => keyPresed(e)}
            tabIndex="0"
            title={
              isPasswodShow
                ? t("global.show_password")
                : t("global.hide_password")
            }
            onClick={() => setIsPasswodShow(!isPasswodShow)}
            icon={isPasswodShow ? faEye : faEyeSlash}
          />
        )}
      </div>
      {errors && errors[[name]] && errors[[name]].message !== "" && (
        <p className={errorClass}>{errors[[name]].message}</p>
      )}
    </div>
  );
  if (parentClass) {
    finalInput = <div className={parentClass}> {finalInput}</div>;
  }
  return finalInput;
};

export default TagInput;
